











import uuid from "uuid/v4";
import { setInterval, clearInterval, setTimeout } from 'timers';

import {nextTick} from "process";

import { Component, Vue, Prop } from "vue-property-decorator";
import { constants } from "http2";

@Component({

})
export default class Ripple extends Vue {
    @Prop({}) flavor: ("dark" | "light");
    @Prop({}) circle: boolean;
    ripples = [];
    updateTimerID: any | false = false;
    mouseDownListener: any;
    mouseUpListener: any;
    prevEventEnded:boolean = true;

    mounted() { 
        this.mouseDownListener = (event) => {
            
            if(this.prevEventEnded == false) return;
            this.prevEventEnded = false;

            let rippleContainer = this.$refs.rippleContainer as HTMLElement;
            let rippleContainerConstrains = rippleContainer.getBoundingClientRect();

            let containerX = rippleContainerConstrains.left;
            let containerY = rippleContainerConstrains.top;

            let x = event.clientX - containerX || event.touches[0].clientX - containerX;
            let y = event.clientY - containerY || event.touches[0].clientY - containerY;

            let parentWidth = rippleContainer.offsetWidth;
            let parentHeight = rippleContainer.offsetHeight;

            let biggestWH = Math.max(parentWidth,parentHeight);

            let parentWidthH = parentWidth / 2;
            let parentHeightH = parentHeight / 2;

            let centreOffsetX = Math.abs(parentWidthH - x);
            let centreOffsetY = Math.abs(parentHeightH - y);

            let maxCircleSize = (Math.max(centreOffsetX,centreOffsetY) * 2 + biggestWH) * 1.5;

            this.newRipple(x,y,maxCircleSize);
        };

        this.mouseUpListener = (event) => {
            setTimeout(()=>{
                this.prevEventEnded = true;
            },10)
            this.flagRipples();
        };

        let rippleContainer = this.$refs.rippleContainer as Element;
        rippleContainer.parentElement.addEventListener("mousedown",this.mouseDownListener);
        rippleContainer.parentElement.addEventListener("touchstart",this.mouseDownListener);
        // TODO touchstart does not trigger the event in the right x,y location
        // from memory, this is to do with touch.originalEvents[0 -> X], where x is the number of fingers down
        rippleContainer.parentElement.addEventListener("mouseout",this.mouseUpListener);
        rippleContainer.parentElement.addEventListener("touchout",this.mouseUpListener);
        rippleContainer.parentElement.addEventListener("mouseup",this.mouseUpListener);
        rippleContainer.parentElement.addEventListener("touchend",this.mouseUpListener);
    }
    
    beforeDestroy() {
        let rippleContainer = this.$refs.rippleContainer as Element;
        if(!rippleContainer.parentElement) {return;}
        rippleContainer.parentElement.removeEventListener("mousedown",this.mouseDownListener);
        rippleContainer.parentElement.removeEventListener("touchstart",this.mouseDownListener); 
        rippleContainer.parentElement.removeEventListener("mouseout",this.mouseUpListener);
        rippleContainer.parentElement.removeEventListener("touchout",this.mouseUpListener);
        rippleContainer.parentElement.removeEventListener("mouseup",this.mouseUpListener);
        rippleContainer.parentElement.removeEventListener("touchend",this.mouseUpListener);
    }

    newRipple(centerX,centerY,maxDiameter) {
        let ripple = {
            id: uuid(),
            createdAt: Date.now(),
            deletedAt: 0,

            mouseReleased: false,

            posX: centerX,
            posY: centerY,

            maxSize: maxDiameter,

            style: {
                background: this.flavor !== "light" ? `rgba(0,0,0,0.1)` : `rgba(255,255,255,0.3)`,
                left: `${centerX - (maxDiameter / 2)}px`,
                top: `${centerY - (maxDiameter / 2)}px`,
                opacity: "1",
                width: `${maxDiameter}px`,
                height: `${maxDiameter}px`,
                transform: "scale3d(0,0,0)",
                transition: "all 0.6s cubic-bezier(0,.91,.54,1);",
            },
        };
        this.ripples.push(ripple);

        nextTick(() => {
            ripple.style.transform = "scale3d(1,1,1)";
        })

        if(this.updateTimerID === false) {
            this.updateTimerID = setInterval(() => {
                if(this.ripples.length === 0) {
                    clearInterval(this.updateTimerID);
                    this.updateTimerID = false;

                    return;
                }

                this.updateRipples();
            },1000);
        }
    }
    
    flagRipples() {
        for(let ripple of this.ripples) {
            if(!ripple.mouseReleased) {
                ripple.mouseReleased = true;
                ripple.style.opacity = "0";
                ripple.deletedAt = Date.now()
            }
        }
    }

    updateRipples() {
        let i = 0;
        while(i < this.ripples.length) {
            let ripple = this.ripples[i];

            if(ripple.mouseReleased && ((Date.now() - ripple.deletedAt) > 1000)) {
                this.ripples.splice(i,1);
            }
            else {
                i++;
            }
        }
    }
}

